export default __webpack_public_path__ + "static/media/track2.55a84b82.svg";